(() => {
  const configNode = document.getElementById('SfMarketLanguageConfig');
  const autoForm = document.getElementById('SfMarketLanguage');
  if (!configNode || !autoForm) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  const defaults = {US:'en',CA:'en',GB:'en',IE:'en',DE:'de',AT:'de',CH:'de',SE:'sv',NO:'nb',PL:'pl',NL:'nl',DK:'da',FI:'fi',BE:'fr',FR:'fr',CZ:'cs'};
  const normalizeCountry = value => value === 'UK' ? 'GB' : value;
  const localePrefix = path => config.languages.find(code => code !== 'en' && (path === '/' + code || path.startsWith('/' + code + '/')));
  const readPreference = country => { try { return localStorage.getItem('sf-language:' + country); } catch { return null; } };
  const remember = (country, language) => { try { localStorage.setItem('sf-language:' + country, language); } catch {} };
  const supported = language => config.languages.includes(language);
  const defaultLanguage = country => supported(readPreference(country)) ? readPreference(country) : defaults[country];
  const setField = (form, name, value) => {
    let field = form.elements.namedItem(name);
    if (!field) { field = document.createElement('input'); field.type = 'hidden'; field.name = name; form.appendChild(field); }
    field.value = value;
  };
  function prepare(form, country, language, explicit) {
    const url = new URL(window.location.href);
    const prefix = localePrefix(url.pathname);
    if (prefix) url.pathname = url.pathname.slice(prefix.length + 1) || '/';
    url.searchParams.set('country', country);
    if (explicit) url.searchParams.set('language', language); else url.searchParams.delete('language');
    setField(form, 'country_code', country);
    setField(form, 'language_code', language);
    setField(form, 'return_to', url.pathname + url.search + url.hash);
  }
  const countryForm = document.getElementById('SfFooterCountry');
  if (countryForm) countryForm.addEventListener('change', event => {
    if (event.target.name !== 'country_code') return;
    const country = normalizeCountry(event.target.value);
    const language = defaultLanguage(country);
    if (!config.countries.includes(country) || !supported(language)) return;
    prepare(countryForm, country, language, false);
    countryForm.requestSubmit();
  });
  const languageForm = document.getElementById('SfFooterLanguage');
  if (languageForm) languageForm.addEventListener('change', event => {
    if (event.target.name !== 'language_code' || !supported(event.target.value)) return;
    remember(config.country, event.target.value);
    prepare(languageForm, config.country, event.target.value, true);
    languageForm.requestSubmit();
  });
  const url = new URL(window.location.href);
  const country = normalizeCountry((url.searchParams.get('country') || '').toUpperCase());
  if (!country || !defaults[country] || !config.countries.includes(country)) return;
  const explicit = url.searchParams.get('language');
  const language = supported(explicit) ? explicit : localePrefix(url.pathname) || defaultLanguage(country);
  if (!supported(language) || (country === config.country && language === config.language)) return;
  const attempt = 'sf-market-route:' + country + ':' + language + ':' + url.pathname;
  try {
    const last = Number(sessionStorage.getItem(attempt) || 0);
    if (Date.now() - last < 30000) return;
    sessionStorage.setItem(attempt, String(Date.now()));
  } catch { return; }
  prepare(autoForm, country, language, Boolean(explicit));
  autoForm.requestSubmit();
})();
